export default {
    name: 'naam',
    tel: 'Telefoon',
    save: 'Opslaan',
    confirm: 'Bevestigen',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    complete: 'Volledig',
    loading: 'Bezig met laden...',
    telEmpty: 'Vul het tel in',
    nameEmpty: 'Vul de naam in',
    nameInvalid: 'Verkeerde naam',
    confirmDelete: 'Weet u zeker dat u wilt verwijderen',
    telInvalid: 'Onjuist opgemaakt telefoonnummer',
    vanCalendar: {
      end: 'Einde',
      start: 'Beginnen',
      title: 'Kalender',
      startEnd: 'Beginnen/Einde',
      weekdays: ['Zon', 'Maan', 'Dins', 'Woens', 'Donder', 'Vrij', 'Zater'],
      monthTitle: (year, month) => `${year}/${month}`,
      rangePrompt: (maxRange) => `Kies niet meer dan ${maxRange} dagen`,
    },
    vanCascader: {
      select: 'Selecteer',
    },
    vanContactCard: {
        addText: 'Contact toevoegen'
    },
    vanContactList: {
        addText: 'Contact toevoegen'
    },
    vanPagination: {
      prev: 'Vorige',
      next: 'Volgende',
    },
    vanPullRefresh: {
      pulling: 'Trekken om te vernieuwen...',
      loosing: 'Los om te verversen...',
    },
    vanSubmitBar: {
      label: 'Totaal:',
    },
    vanCoupon: {
      unlimited: 'Onbeperkt',
      discount: (discount) => `${discount * 10}% korting`,
      condition: (condition) => `Ten minste ${condition}`,
    },
    vanCouponCell: {
      title: 'Waardebon',
      tips: 'Geen coupons',
      count: (count) => `Je hebt ${count} coupons`,
    },
    vanCouponList: {
      empty: 'Geen coupons',
      exchange: 'Uitwisselen',
      close: 'Sluiten',
      enable: 'Beschikbaar',
      disabled: 'Niet beschikbaar',
      placeholder: 'Couponcode',
    },
    vanAddressEdit: {
      area: 'Gebied',
      postal: 'Post',
      areaEmpty: 'Selecteer een ontvangstgebied',
      addressEmpty: 'Adres mag niet leeg zijn',
      postalEmpty: 'Verkeerde postcode',
      defaultAddress: 'Instellen als standaardadres',
      telPlaceholder: 'telefoon',
      namePlaceholder: 'naam',
      areaPlaceholder: 'gebied'
    },
    vanAddressEditDetail: {
        label: 'Adres',
        placeholder: 'Adres'
    },
    vanAddressList: {
      add: 'Nieuw adres toevoegen',
    },
  };